<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Add/Edit Devices</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal('No')"></button>
</div>
<div class="modal-body">
  <lib-vio-input [formsData]="deviceInfo"></lib-vio-input>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success btn-round btn-shadow mx-1" title="Save" [appDisableWhile]="isSubmitting"
    (click)="saveDevice()"><i class="fa fa-save"></i> Save</button>
  <button type="button" class="btn btn-secondary btn-round btn-shadow mx-1" title="Close" (click)="closeModal('No')">
    <i class="fa fa-times-circle"></i> Close
  </button>
</div>